export const infoAccountsSelector = ({ admin }) => admin.infoAccounts.infoAccounts;

export const isFetchingInfoAccountsSelector = ({ admin }) =>
  admin.infoAccounts.isFetchingInfoAccounts;
